import { Component, computed, inject, input, LOCALE_ID, signal } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { NgClass } from '@angular/common';
@Component({
  selector: 'app-image-carousel',
  imports: [NgClass],
  templateUrl: './image-carousel.html',
  styleUrl: './image-carousel.scss',
})
export class ImageCarousel {
  type = input<'offer' | 'product' | 'customer-product' | 'customer-offer'>('product');
  private locale = inject(LOCALE_ID);
  isArabic = computed(() => this.locale.startsWith('ar'));
  profileImage = input<{ url: SafeUrl | string; isImage: boolean } | undefined>();
  extraImages = input<{ url: SafeUrl | string; isImage: boolean }[]>([]);
  isLoading = input<boolean>(false);

  activeIndex = signal(0);

  // Merge profile image + extra images into one array
  allImages = computed(() => {
    const profile = this.profileImage();
    const extras = this.extraImages() ?? [];
    return profile ? [profile, ...extras] : extras;
  });

  currentImage = computed(() => this.allImages()[this.activeIndex()]);

  goTo(index: number) {
    this.activeIndex.set(index);
  }

  prev() {
    this.activeIndex.update((i) => (i - 1 + this.allImages().length) % this.allImages().length);
  }

  next() {
    this.activeIndex.update((i) => (i + 1) % this.allImages().length);
  }
}
